import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { getStep } from './../../route-component';
import ProgressBar from './ProgressBar';
import Heading from './Heading';
import MainPitch from './MainPitch';
import NextBtn from './NextBtn';
import config from './../../config';
import common from './../../common';
import Matches from "../matches";

class SelectCaptain extends Component {
    handleNext = () => {
        // return this.props.history.push('/select-badge');
        return this.props.history.push('/team-name');
    };

    render() {
        const playerCount = this.props.teamData.playerCount || 0;
        if (playerCount !== config.MAX_PLAYERS_PER_TEAM) {
            return <Redirect to={'/create-team'} />
        }
        const location = this.props.location;
        const wrapperClass = common.makeClasses({
            'si-main-component': true,
            'si-select-captain': true,
            'si-no-anim': true,
        });
        const { captainID } = this.props.teamData;
        const isDisabled = captainID === null;
        return (
            <React.Fragment>
                <div className={wrapperClass}>
                    <div className="si-container">
                        <div className="si-top-section si-mob">
                            <ProgressBar />
                            <Heading title={this.props.trans['choose_your_captain']} {...{ isDisabled }}
                                text={this.props.trans.next}
                                captainText={this.props.trans['captain_will_get']}
                                showTitle={isDisabled} tooltipText={this.props.trans.select_your_captain}
                                handler={() => this.handleNext()} />
                        </div>
                        <MainPitch toShowList={getStep(location.pathname) === 0} {...{ isDisabled }} />
                        {/* <div className="si-btn-wrp">
                            <NextBtn {...{ isDisabled }}
                                text={"this.props.trans.next"}
                                showTitle={isDisabled} tooltipText={this.props.trans.select_your_captain}
                                handler={() => this.handleNext()} />
                        </div> */}
                    </div>

                </div>
                {
                    (!config.isMobile)
                        ?
                        <Matches {...this.props}/>
                        :
                        null
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        teamData: state.formationData.teamData,
    };
};
export default withRouter(connect(mapStateToProps, null)(SelectCaptain));


// WEBPACK FOOTER //
// ./src/components/onboarding/SelectCaptain.js